import { workingDaysBetweenDates } from '../../utils'

const tasks = (state = [], action) => {
    switch (action.type) {
        case 'ADD_TASK':
            return [
                ...state,
                {
                    id: action.id,
                    title: action.title,
                    status: action.status,
                    startDate: action.startDate,
                    endDate: action.endDate
                }
            ]

        case 'CHANGE_TASK_DATES':
            return state.map(task =>
                task.id === action.taskId
                    ? {
                          ...task,
                          startDate: action.startDate,
                          endDate: action.endDate,
                          duration: workingDaysBetweenDates(action.startDate, action.endDate) || 1
                      }
                    : task
            )

        default:
            return state
    }
}

export default tasks
